import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
    Action,
    createFeatureSelector,
    createReducer,
    createSelector,
    on
} from '@ngrx/store';
import { IWeeklySummary } from '../IWeeklySummary';
import * as WeeklySummaryActions from './weekly-summary.actions';

export const weeklySummariesFeatureKey = 'weeklySummaries';

export interface State extends EntityState<IWeeklySummary> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IWeeklySummary> =
    createEntityAdapter<IWeeklySummary>();
export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const weeklySummaryReducer = createReducer(
    initialState,
    on(WeeklySummaryActions.addWeeklySummary, (state, action) =>
        adapter.addOne(action.weeklySummary, state)
    ),
    on(WeeklySummaryActions.upsertWeeklySummary, (state, action) =>
        adapter.upsertOne(action.weeklySummary, state)
    ),
    on(WeeklySummaryActions.addWeeklySummarys, (state, action) =>
        adapter.addMany(action.weeklySummarys, state)
    ),
    on(WeeklySummaryActions.upsertWeeklySummarys, (state, action) =>
        adapter.upsertMany(action.weeklySummarys, state)
    ),
    on(WeeklySummaryActions.updateWeeklySummary, (state, action) =>
        adapter.updateOne(action.weeklySummary, state)
    ),
    on(WeeklySummaryActions.updateWeeklySummarys, (state, action) =>
        adapter.updateMany(action.weeklySummarys, state)
    ),
    on(WeeklySummaryActions.deleteWeeklySummary, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(WeeklySummaryActions.deleteWeeklySummarys, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(WeeklySummaryActions.loadWeeklySummarys, (state, action) =>
        adapter.setAll(action.weeklySummarys, state)
    ),
    on(WeeklySummaryActions.clearWeeklySummarys, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return weeklySummaryReducer(state, action);
}
const localState = createFeatureSelector<State>(weeklySummariesFeatureKey);
export const getEntities = createSelector(localState, x => x.entities);
export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(localState);
